import { useTranslation } from "react-i18next";

export default function TechByTechRoleHeader({
  techRoles,
  onChange,
  selectedTechRole
}) {
  let { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-sm">
        <ul className="list-inline mt-2">
          <li className="list-inline-item">
            <div className="form-group">
              <select
                required
                title={t("Selecione um item da lista.")}
                name="techRoleId"
                onChange={onChange}
                value={selectedTechRole.id || ""}
              >
                <option key={0} value="" selected>
                  {t("Tech Role...")}
                </option>
                {techRoles.map((techrole) => (
                  <option key={techrole.id} value={techrole.id}>
                    {` ${t(techrole.techArea)}/ ${t(techrole.description)}`}
                  </option>
                ))}
              </select>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
